<template>
  <div class="result-list" v-if="!loading">
    <Miniform class="mb-4" />
    <header class="page-header">
      <h1>{{ $lang.translate('track.header.searchResults') }}</h1>
      <span class="result-count" v-if="results.length">
        {{ $lang.translate('track.label.showing').replace('{0}', results.length).replace('{1}', results.length) }}
      </span>
    </header>    
    <p v-if="results.length == 0">{{ $lang.translate('track.message.noResults') }}</p>
    <Result v-for="(result, index) in results" :result="result" :key="index" :searchKey="searchKey" />
    
  </div>
</template>

<script>
import { store } from '@/store'
import Result from '@/components/Result'
import Miniform from '@/components/Miniform'
import { cleanUrlParam } from '@/utils'

export default {
  name: 'ResultList',
  data () {
    return {
      searchKey: ''
    }
  },
  computed: {
    results() {
      return store.results
    },
    loading() {
      return store.loading
    },
    allSystemsLoaded () {
      return store.allSystemsLoaded
    }
  },
  components: {
    Result,
    Miniform
  },
  mounted () {
    this.searchKey = this.$route.query.key ? this.$route.query.key : ''
    if (this.allSystemsLoaded && Array.isArray(this.results) && this.results.length === 1) { 
      this.$router.push({path: `/s/${cleanUrlParam(this.$route.params.trackingNumber)}/d/${cleanUrlParam(this.results[0].details.uniqueId)}`})
    }
  }
}
</script>

<style>
.result-list .result-count {
  font-size: 13px;
  color: #2E353D80;
}
.result-list header.page-header {
  margin-bottom: 18px;
}
</style>